/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AtsJobDtoFromJSON, AtsJobDtoToJSON, } from './AtsJobDto.js';
/**
 * Check if a given object implements the ListAtsJobsResult interface.
 */
export function instanceOfListAtsJobsResult(value) {
    if (!('jobs' in value) || value['jobs'] === undefined)
        return false;
    return true;
}
export function ListAtsJobsResultFromJSON(json) {
    return ListAtsJobsResultFromJSONTyped(json, false);
}
export function ListAtsJobsResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'jobs': (json['jobs'].map(AtsJobDtoFromJSON)),
    };
}
export function ListAtsJobsResultToJSON(json) {
    return ListAtsJobsResultToJSONTyped(json, false);
}
export function ListAtsJobsResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'jobs': (value['jobs'].map(AtsJobDtoToJSON)),
    };
}
